export const replaceDynamicTranslation = (value: string, replaceWith: string): string => {
    value = value.replace(/\|\|([0-9]+)\|\|/g, function(fullMatch, capture) {
        return replaceWith;
    });

    return value;
};

export const parseString = (str: string) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
};

export const getUrlParam = (url: string, name: string): string => {
    name = name.replace(/[\[\]]/g, "\\$&");

    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

    if (!results) {
        return '';
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const replaceMeCaseInsensitive = (
    stringToChange: string,
    searchFor: string,
    replaceWith: string
) => {
    const regEx: any = new RegExp(searchFor, 'ig');

    const result: string = stringToChange.replace(regEx, replaceWith);

    return result;
};

export const expandString = (str: string, charWidth: number) =>
    str
        .split('')
        .map((char: string, index: number) => ((index + 1) % charWidth !== 0 ? char : `${char} `));
